'use client';

import { useDecisions } from '../../../hooks';
import { getENV } from '../../../utils/env';

// This script contains two parts:
// 1. GTM callback function - Called by Contextual Commerce when user is assigned to A/B test group ('baseline' or 'granify').
//    Sends group assignment data to Google Tag Manager for analytics tracking and personalization.
// 2. Contextual Commerce activation - Initializes the BazaarVoice Contextual Commerce library
const contextualCommerceScript = (siteId: string) => `
window.granifyEventGroupAssigned = function(group) {
  dataLayer.push({
    event: 'gfy.groupAssigned',
    granifyGroup: group,
  });
}
function activateGranify(sid) {
	if (!window.Granify) !function(r,t,e){
		var a,n;
		try{
			var i=window.localStorage,o="granify.entry_page."+t,c="granify.entry_referrer."+t;
			if(n=JSON.parse(i.getItem(o)),n&&parseInt(n.expires)>+new Date?n=n.data:(n=null,i.removeItem(o)),!n){
				i.removeItem(c),i.removeItem("granify.entry_page_sent."+t),i.removeItem("granify.entry_referrer_sent."+t);
				var s=window.location,f=window.location.origin;
				a=new Date(+new Date+18e5),f||(s.port?port=":"+s.port:port="",f=s.protocol+"//"+s.hostname+port);
				var y={data:window.location.toString().replace(f,""),expires:+a},p={data:document.referrer,expires:+a};
				i.setItem(o,JSON.stringify(y)),i.setItem(c,JSON.stringify(p))
			}
		} catch(r) {}
		r=r+(-1===r.indexOf("?")?"?":"&")+"id="+t,window.Granify=function(r,t){Granify._functionsAvailable?Granify[r].apply(this,Array.prototype.slice.call(arguments,1)):Granify._stack.push([r].concat(Array.prototype.slice.call(arguments,1)))},Granify._stack=[],Granify._stack.push(["on","granify:init",function(){Granify._functionsAvailable=!0}]),Granify.init=function(r,t,e){for(var a=Granify,n=["on","identify","addTag","trackPageView","trackProduct","trackCart","addToCart","deleteFromCart","trackOrder","setCurrentProduct"],i=0;i<n.length;i++)!function(r,t){r[t]=function(){Granify._stack.push([t].concat(Array.prototype.slice.call(arguments,0)))}}(a,n[i])},Granify.init();var l,d=document.createElement("script");d.src=r,d.async=!0,(l=(l=document.getElementsByTagName("script"))[l.length-1]).parentNode.insertBefore(d,l)
	}("//cdn.granify.com/assets/javascript.js",sid);
}
activateGranify("${siteId}");
`;

/*
    This is component loads the BazaarVoice Contextual Commerce script.
    BazaarVoice Contextual Commerce (commonly referred to as "CoCo") is a feature that allows us to track user behavior on our site and use that data to personalize the user's experience.
    https://docs.bazaarvoice.com/articles/#!contextual-commerce/introduction-to-coco
    https://docs.bazaarvoice.com/articles/#!contextual-commerce/web-installation
    This script is a separate feature than BazaarVoice Customer Reviews, which is loaded via the BazaarVoiceScript.tsx component. BazaarVoiceScript component is loaded on the PDP.
    Note: BazaarVoice bought Granify and renamed it to Contextual Commerce.
    Note: [08/29/2025] Our contract with BazaarVoice is only used for the US site currently.
    Note: CA support is future-proofed - when NEXT_PUBLIC_BAZAAR_VOICE_SITE_ID_CA is added, CA sites will automatically start using it.
*/

// TODO: Convert this to the client component in the https://petsmart.atlassian.net/browse/SB-3149
export const BazaarVoiceContextualLegacy = () => {
    const isBazaarVoiceCocoEnabled = useDecisions('bazaarvoice_coco');
    const nextPublicBazaarVoiceSiteIdCa = getENV('NEXT_PUBLIC_BAZAAR_VOICE_SITE_ID_CA');
    const nextPublicBazaarVoiceSiteIdUs = getENV('NEXT_PUBLIC_BAZAAR_VOICE_SITE_ID_US');

    // Determine which site ID to use based on locale
    const isCA = getENV('NEXT_PUBLIC_LOCALE') === 'en-CA';
    const bazaarVoiceSiteId = isCA ? nextPublicBazaarVoiceSiteIdCa : nextPublicBazaarVoiceSiteIdUs;

    if (!isBazaarVoiceCocoEnabled || !bazaarVoiceSiteId) return null;

    return (
        <script
            id="bazaarvoice-contextual-commerce"
            dangerouslySetInnerHTML={{ __html: contextualCommerceScript(bazaarVoiceSiteId) }}
        />
    );
};
